
export default function UsersRoles() {
  const roles = [
    {
      title: 'System Administrators',
      icon: 'ri-settings-3-line',
      description: 'Configure organizational settings, manage user permissions, define templates, and oversee compliance requirements across all modules.',
      responsibilities: ['Global system configuration', 'User and role management', 'Template and workflow creation', 'Audit and compliance oversight'],
      gradient: 'from-[#182423] to-[#2a3d3b]'
    },
    {
      title: 'Project Managers',
      icon: 'ri-folder-chart-line',
      description: 'Oversee project-level operations, monitor quality and safety metrics, manage documentation, and coordinate between site teams and leadership.',
      responsibilities: ['Project setup and configuration', 'Team coordination and reporting', 'Quality and safety monitoring', 'Document approval workflows'],
      gradient: 'from-[#F16051] to-[#e54d3d]'
    },
    {
      title: 'Site Engineers',
      icon: 'ri-tools-line',
      description: 'Execute daily inspections, complete quality checklists, manage asset records, and report incidents directly from construction sites.',
      responsibilities: ['Daily inspection completion', 'Asset tracking and maintenance', 'Quality checklist execution', 'Incident documentation'],
      gradient: 'from-[#182423] to-[#2a3d3b]'
    },
    {
      title: 'Site Workers',
      icon: 'ri-hard-hat-line',
      description: 'Access safety procedures, complete required forms, report hazards, and view relevant documentation through simplified mobile interfaces.',
      responsibilities: ['Safety induction completion', 'Hazard and incident reporting', 'Form submission', 'Document access'],
      gradient: 'from-[#F16051] to-[#e54d3d]'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <span className="inline-block px-4 py-2 rounded-full text-sm font-semibold mb-4" style={{ backgroundColor: '#182423', color: 'white' }}>
              User Research
            </span>
            <h2 className="text-4xl md:text-5xl font-bold" style={{ color: '#182423' }}>
              Users & Roles
            </h2>
          </div>
          <p className="text-lg text-gray-600 max-w-md">
            Understanding role-based requirements was critical to designing an interface that scales across organizational hierarchies.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {roles.map((role, index) => (
            <div key={index} className="group relative bg-white rounded-3xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-xl transition-all duration-300">
              {/* Header with gradient */}
              <div className={`bg-gradient-to-r ${role.gradient} p-6`}>
                <div className="flex items-center gap-4">
                  <div className="w-14 h-14 bg-white/20 backdrop-blur-sm rounded-2xl flex items-center justify-center">
                    <i className={`${role.icon} text-white text-2xl`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-white">{role.title}</h3>
                </div>
              </div>
              
              {/* Content */}
              <div className="p-6">
                <p className="text-gray-600 leading-relaxed mb-6">{role.description}</p>
                
                <div>
                  <h4 className="text-xs font-bold uppercase tracking-wider text-gray-400 mb-3">
                    Key Responsibilities
                  </h4>
                  <div className="flex flex-wrap gap-2">
                    {role.responsibilities.map((resp, idx) => (
                      <span 
                        key={idx} 
                        className="px-3 py-1.5 bg-gray-100 text-gray-700 text-sm rounded-full"
                      >
                        {resp}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
